import React, { useState, useEffect } from 'react';
import '../App.css';
import { useHistory, useLocation } from 'react-router-dom';
import user from '../assets/user.png';
import MyStorage from './util/storage';
import MyLoader from './util/loader';
import { ToastContainer } from 'react-toastify';

const HomeProgramSales = () => {
    const history = useHistory();

    const location = useLocation();
    const programs = location.state.programs;

    const [models, setModels] = useState(programs);
    const [loader, setLoader] = useState(false);

    // load data
    useEffect(() => {
        //
    }, []);

    const getProfilePhoto = (model) => {
        if (MyStorage.getFileUrls() == null || model.photo == null || model.photo === '') {
            return user
        }
        else {
            if (model.photo.includes('http')) {
                return model.photo
            }
            return MyStorage.getFileUrls().User + model.photo
        }
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Program Sales
                </div>
            </div>
            <div style={{ marginTop: 30 }}></div>

            {models.map((model, index) => {
                console.log('MODEL: ' + JSON.stringify(model));
                let className = index % 2 !== 0 ? 'projects-itembar' : 'projects-itembar-colored'
                return (
                    <div className={className} style={{ display: 'flex', flexDirection: 'column',  alignItems:'flex-start'}} >
                        
                        <div className='projects-item-cat' style={{}}>
                            <div style={{ fontSize: 16, fontWeight:'bold' }}>{model.special_program.title}</div>
                        </div>
                        <div className='projects-item-cat' style={{}}>
                            <div style={{ fontSize: 16 }}>Payed and Joined by User #{model.user_id}</div>
                        </div>
                        <div className='projects-item-cat' style={{}}>
                            <div style={{ fontSize: 16 }}>Joined on {model.added_date.split(' ')[0]}</div>
                        </div>
                        {/* <div className={className} style={{ marginTop: 0 }}> */}
                        {/* <div className='projects-item-photo'>
                                <img src={getProfilePhoto(model.user)} style={{ padding: 1, width: 70, height: 70 }} />
                            </div> */}
                        {/* <div className='projects-item-cat' style={{}}>
                                <div style={{ fontSize: 16 }}>Joined by User #{model.user_id}</div>
                            </div>
                            <div className='projects-item-cat' style={{}}>
                                <div style={{ fontSize: 16 }}>Program: {model.special_program.title}</div>
                            </div> */}

                        {/* <div className='projects-item-cat' style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Button
                                    className='btn-block btn-submit'
                                    style={{ width: 120, fontSize: 16 }}
                                    onClick={() => {
                                        console.log('click');
                                        history.push({
                                            pathname: '/user-details',
                                            state: { user: model.user }
                                        })
                                    }}>
                                    View Details
                                </Button>
                                <Button
                                    style={{ width: 100, backgroundColor: 'red', marginLeft: 10, fontSize: 16 }}
                                    className='btn-block btn-submit'
                                    onClick={() => {
                                        console.log('click');
                                        removeMember(model.user.id)
                                    }}>
                                    Remove
                                </Button>
                            </div> */}

                        {/* </div> */}
                    </div>
                );
            })}

            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default HomeProgramSales;